import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';

const FLOWLEDGER_ICON = "https://customer-assets.emergentagent.com/job_flowsecure-fintech/artifacts/jw6e8f7s_7B7D7191-078E-4AB2-A5E6-D847E0D60608.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    products: [
      { name: 'FlowLedger', path: '/flowledger' },
      { name: 'SIMVault', path: '/simvault' },
      { name: 'Pricing', path: '/pricing' },
    ],
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'FAQ', path: '/faq' },
      { name: 'Contact', path: '/contact' },
    ],
    resources: [
      { name: 'Documentation', path: '#' },
      { name: 'API Reference', path: '#' },
      { name: 'Support', path: '/contact' },
    ],
  };

  return (
    <footer data-testid="footer" className="bg-[#003C83] text-white">
      <div className="container-main py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <img 
                src={FLOWLEDGER_ICON} 
                alt="TrustBridge" 
                className="w-10 h-10 object-contain"
              />
              <span className="font-semibold text-xl">TrustBridge</span>
            </div>
            <p className="text-[#66B2FF] mb-6 max-w-sm leading-relaxed">
              Providing secure transaction infrastructure for businesses in Liberia and Africa. 
              Empowering entrepreneurs with reliable mobile money solutions.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#00479E] flex items-center justify-center hover:bg-[#0080FF] transition-colors"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#00479E] flex items-center justify-center hover:bg-[#0080FF] transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Products Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Products</h4>
            <ul className="space-y-3">
              {footerLinks.products.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-[#66B2FF] hover:text-white transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-[#66B2FF] hover:text-white transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-[#66B2FF]">
                <Mail className="w-4 h-4" />
                <span>hello@trustbridgeflow.com</span>
              </li>
              <li className="flex items-center gap-3 text-[#66B2FF]">
                <Phone className="w-4 h-4" />
                <span>+231 770 000 000</span>
              </li>
              <li className="flex items-start gap-3 text-[#66B2FF]">
                <MapPin className="w-4 h-4 mt-1" />
                <span>Monrovia, Liberia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#00479E] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#66B2FF] text-sm">
            {currentYear} TrustBridge Technologies. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="#" className="text-[#66B2FF] hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="text-[#66B2FF] hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
